import { render, staticRenderFns } from "./ModelsLiquidations.vue?vue&type=template&id=7183c6b4"
import script from "./ModelsLiquidations.vue?vue&type=script&lang=js"
export * from "./ModelsLiquidations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports